import styled from 'styled-components';
import { Container } from 'Common';

export default styled(Container)``;
